import { SVGPropsIcon } from 'src/types';

export const PlayButtonIcon = (props: SVGPropsIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="89"
    height="91"
    viewBox="0 0 89 91"
    fill="none">
    <path
      d="M80.8308 42.4806C83.148 43.8308 83.148 47.1785 80.8308 48.5287L29.0121 78.7233C26.6788 80.0829 23.75 78.3997 23.75 75.6992L23.75 15.31C23.75 12.6095 26.6788 10.9264 29.0121 12.286L80.8308 42.4806Z"
      stroke="url(#paint0_linear_18826_68814)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_18826_68814"
        x1="89"
        y1="45.5046"
        x2="-1.94516e-06"
        y2="45.5046"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A8FF28" />
        <stop offset="1" stopColor="#2BB83E" />
      </linearGradient>
    </defs>
  </svg>
);
